import { Component, EventEmitter, Input, Output } from '@angular/core';
import { VhEventMediator, VhQueryAutoWeb } from 'vhautowebdb';
import { AtwUpdateDbComponent } from 'vhobjects-service';
import { FunctionService  } from 'vhobjects-service';

@Component({
  selector: 'atw-image-detail-admin-config-image',
  templateUrl: './image-detail-admin-config-image.component.html',
  styleUrls: ['./image-detail-admin-config-image.component.scss']
})
export class AtwImageDetailAdminConfigImage extends AtwUpdateDbComponent {
@Input() objectChoosing: any; // lấy giá trị data trả vể từ page
  @Input() class: any; // là dữ liệu desktop_class hoặc mobile_portrait_class từ database
  @Input() data: any = {};
  @Input() device: any; // xác định device là desktop hay mobile
  @Input() staticdata: any; // là dữ liệu staticdata từ database
  @Input() config: any;@Input() type: any; // là dữ liệu desktop_config hoặc mobile_portrait_config từ database

  /** Emit sự kiện chỉnh viền chi tiết border-radius cho ảnh chính */
  @Output() openViewDetail = new EventEmitter();

  currentViewAll: any = {};
  isViewAll: boolean = false;


  constructor(
    public vhQueryAutoWeb: VhQueryAutoWeb,
    public functionService: FunctionService,
    public vhEventMediator: VhEventMediator,
  ) {
    super(vhQueryAutoWeb, vhEventMediator, functionService);
  }
  

  /**
   * Xử lý cập nhật độ co giãn
   */
  updateScale() {
    this.class['image-img'].transform = "scale(" + (this.config['transform_image'].transform_scale * 100) + "%)";
    this.updateClass();
    this.updateConfig();
  }


  /**
   * Xử lý cập nhật Vị trí ảnh
   */
  handleSetPositionImage() {
    if (this.config['object_fit_image']['object_x'] == 0 && this.config['object_fit_image']['object_y'] == 0)
      this.class['image-img']['object-position'] = 'initial';
    else {
      this.class['image-img']['object-position'] = `${this.config['object_fit_image']['object_x']}px ${this.config['object_fit_image']['object_y']}px`;
    }
    this.updateClass();
    this.updateConfig();
  }


  /* ---------------------------- XỬ LÝ MENU CONFIG --------------------------- */

  isOpenViewAll(event){
    this.currentViewAll = event;
    this.isViewAll = !this.isViewAll;
  }


  /**
   * Hàm này dùng để mở rộng phần cấu hình.
   * @param field_text : trả về phần tử được chọn của mảng style_field
   */
  openViewAll(field_text) {
    this.currentViewAll = field_text;
    this.isViewAll = !this.isViewAll;
  }


  /**
   * Hàm này dùng để cho phép mở menu config .
   * Khi mở ở vị trí menu[0] thì các menu khác (menu[n]) đóng lại.
   * @param: value
   */
  openHandler(value: string): void {
    for (const key in this.openMap) {
      if (key !== value) {
        this.openMap[key] = false;
      }
    }
  }


  openMap: { [name: string]: boolean } = {
    menu1: true,
    menu2: false,
    menu3: false,
    menu4: false,
    menu5: false,
  };


  /* -------------------------- CÁC HÀM UPDATE CƠ BẢN ------------------------- */

  // /**
  // * Hàm update class vào database.
  // */
  // updateClass() {
  //   this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_class']: this.class })
  //     .then((bool: any) => {
        
  //     })
  // }


  // /**
  // * Hàm update config vào database.
  // */
  // updateConfig() {
  //   this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_config']: this.config })
  //     .then((bool: any) => {

  //     })
  // }


  // /**
  // * Hàm update object vào database.
  // */
  // updateObject() {
  //   this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_class']: this.class, [this.device + '_config']: this.config, staticdata: this.staticdata })
  //     .then((bool: any) => {
        
  //     })
  // }
}
